(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lasura-collection-head"] && !Shopify.designMode) return;
  try {
    
  /* Short wide screens: More opens the clamped description (the text is in the page either way). */
  document.addEventListener('click', (event) => {
    const more = event.target instanceof Element ? event.target.closest('[data-chead-more]') : null;
    if (!more) return;
    const intro = document.getElementById(more.getAttribute('aria-controls'));
    const open = more.getAttribute('aria-expanded') !== 'true';
    intro?.classList.toggle('is-open', open);
    more.setAttribute('aria-expanded', String(open));
    more.hidden = open;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lasura-footer-dog"] && !Shopify.designMode) return;
  try {
    
  class LasuraFooterDog extends HTMLElement {
    connectedCallback() {
      const load = () => {
        this.querySelectorAll('image[data-href]').forEach((image) => {
          image.setAttribute('href', image.dataset.href);
          image.removeAttribute('data-href');
        });
      };
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        load();
        return;
      }
      this.classList.add('is-pending');
      /* Load the image a little before the footer arrives, then walk in once it is in view. */
      const near = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          load();
          near.disconnect();
        }
      }, { rootMargin: '0px 0px 400px 0px' });
      const seen = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          load();
          this.classList.replace('is-pending', 'is-in');
          seen.disconnect();
        }
      }, { threshold: 0.5 });
      near.observe(this);
      seen.observe(this);
    }
  }

  if (!customElements.get('lasura-footer-dog')) customElements.define('lasura-footer-dog', LasuraFooterDog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
